module.exports = __webpack_public_path__ + "img/mixonium-logo-thumb-white.ae411c1c.png";